import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
  standalone: false,
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent {
  @Input() items: any[] = [];
  @Input() columns: { header: string; field: string; type?: string }[] = [];
  @Input() editFunction: (item: any) => void = () => {};
  @Input() deleteFunction: (id: number) => void = () => {};
  @Input() emptyMessage: string = 'no-items-found';
  @Input() loading: boolean = false;
  @Input() page: number = 1;
  @Input() pageSize: number = 10;
  @Input() totalRecords: number = 0;
  @Output() pageChange = new EventEmitter<{ page: number; pageSize: number }>();

  constructor(private modalService: BsModalService) {}

  onLazyLoad(event: TableLazyLoadEvent) {
    const rows = event.rows || this.pageSize;
    const page = Math.floor((event.first || 0) / rows) + 1;

    if (page !== this.page || rows !== this.pageSize) {
      this.pageChange.emit({ page, pageSize: rows });
    }
  }
}
